import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

const X_OFFSET = 16;

export enum EmojiPopoverVariant {
    Hidden = 'hidden',
    Show = 'show',
}

// This animation is currently specific to <MembersPanel />.
// It is possible we revise how this is implemented.
export const emojiPopoverVariants: Variants = {
    [EmojiPopoverVariant.Hidden]: {
        opacity: 0,
        scale: 0.9,
        translateX: X_OFFSET,
    },
    [EmojiPopoverVariant.Show]: {
        opacity: 1,
        scale: 1,
        translateX: 0,
    },
};

export const emojiPopoverTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.3,
};
